import { L } from 'common-translation/tools';

const tips = {
  default: {
    [L.EN]:
      'This page is currently only available in Chinese and will be available in English shortly. Thank you for your patience.',
    [L.JP]:
      'このページは現在英語版のみで提供されており、日本語版も近日中に提供される予定です。ご利用いただきありがとうございます。',
    [L.KO]: '이 페이지는 현재 영어로만 제공되며 한국어 버전은 곧 제공될 예정입니다. 기다려 주셔서 감사드립니다.',
    [L.ZH]: '当前内容仅提供英语版本，中文版我们将尽快补充，感谢您的理解。',
    [L.IND]:
      'Konten saat ini hanya tersedia dalam bahasa inggris, edisi bahasa inggris kami akan segera menambahkan, terima kasih atas pengertian anda.',
    [L.PT]: 'A versão chinesa do conteúdo atual está sendo preparada. Obrigado pela sua compreensão.',
  },
  express: {
    [L.EN]: 'This page is currently only available in English, the language you are viewing is being prepared.',
    [L.JP]: 'このページは現在英語のみで、表示されている言語を準備しています。',
    [L.KO]: '이 페이지는 현재 영어 만 지원하며보고있는 언어를 준비 중입니다.',
    [L.ZH]: '该页面目前只支持英文，你浏览的语言正在准备中。',
    [L.IND]: 'Laman ini saat ini hanya mendukung bahasa inggris, bahasa yang telah anda telusuri sedang dipersiapkan.',
    [L.PT]: 'A versão chinesa do conteúdo atual está sendo preparada. Obrigado pela sua compreensão.',
  },
};

export function getTips(type, language) {
  return tips[type] && tips[type][language] ? tips[type][language] : tips.default[language];
}
